import { Attendee } from '../Models/Attendee';

export class Constants {
    public static readonly USER_ATTENDEE: string = 'k2DtfW3lAZPjyagg7mXkCQ5KSOU2';

    // Dropdown Values
    public static readonly SIZES: string[] = ['S', 'M', 'L', 'XL', 'XXL'];
    public static readonly GENDERS: string[] = ['Male', 'Female'];
    public static readonly STATES: string[] = ['AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI',
        'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI',
        'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV',
        'NY', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT',
        'VA', 'VT', 'WA', 'WI', 'WV', 'WY'];
    public static readonly CHURCH_LIST: string[] = [
        'Other',
        'N/A',
        'AR - Vietnamese Gospel Baptist Church (Fort Smith, Arkansas)',
        'AZ - Vietnamese Baptist Church of Tucson (Tucson, Arizona)',
        'CO - Vietnamese Community Baptist Church (Denver, CO)',
        'GA - Emmanuel Vietnamese Baptist Church (Lake City, GA)',
        'GA - Morrow Vietnamese Alliance Church (Forest Park, GA)',
        'FL - Vietnamese Baptist of Orlando (Orlando, FL)',
        'MD - First Vietnamese Baptist Church (Lanham, MD)',
        'MD - Grace Community Church (Fulton, MD)',
        'MD - Living Faith Vietnamese Baptist Church (Laurel, MD)',
        'MD - Vietnamese Baptist Church of Baltimore (Baltimore, MD)',
        'NC - Vietnamese Alliance Church (Charlotte, NC)',
        'NC - Vietnamese Faith Baptist Church (Charlotte, NC)',
        'NY - Times Square Church (New York, NY)',
        'PA - Philadelphia Bible Church International (Philadelphia, PA)',
        'PA - Pittsburgh Vietnamese Presbyterian Church (Pittsburgh, PA)',
        'PA - Pittsburgh Vietnamese Baptist Church (Pittsburgh, PA)',
        'PA - Redemption City Church (Philadelphia, PA)',
        'PA - Renaissance Church (Pittsburgh, PA)',
        'PA - Vietnamese Alliance Church (Philadelphia, PA)',
        'PA - Vietnamese International Baptist Church of Philadelphia (Philadelphia, PA)',
        'TX - Vietnamese Baptist Church (San Antonio, Texas)',
        'VA - Grace Vietnamese Baptist Church (Fredericksburg, VA)',
        'VA - McLean Bible Church (Vienna, VA)',
        'VA - Vietnamese Baptist Hy Vong Church (Annandale, VA)'
    ];

    public static readonly DAYS_ATTENDING: string[] = [ 'Thursday' , ' Friday', ' Saturday', ' Sunday']; // add thursday if needed


    public static readonly LIST_COLORS: string[] = [
        '#3E65E4', '#810081', '#006500', '#FF0000', '#FF8C00', '#FF65B4', '#008080', '#4fd195', '#C0C0C0', '#d3522e',
        '#ffae19', '#654321', '#c4be6d', '#02076c', '#7166bc', '#e13e46', '#b69652', '#7c5f5d', '#e97f99', '#1c1f32',
        '#4c4e42', '#4c7b84', '#531747', '#331182', '#5cb3b7'
    ];

    public static readonly COST = 160;

    static isNotNull(value: any): boolean {
        if (value != null && value != undefined && value != '') {
            return true;
        }
        else {
            return false;
        }
    }

    static returnValueOrNull(value: any) {
        if (value != null && value != undefined && value != '') {
            return value;
        }
        else {
            return null;
        }
    }
}
